import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type IconProps = Partial<SVGIconProps>;

const UserProfile: FC<IconProps> = (props) => (
  <SVGIcon viewBox="0 0 20 20" {...props}>
    <svg
      fill="none"
      height="20"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.1 10.65c-.058-.008-.133-.008-.2 0-1.467-.05-2.633-1.25-2.633-2.725A2.73 2.73 0 0 1 10 5.191c1.508 0 2.733 1.225 2.733 2.733A2.73 2.73 0 0 1 10.1 10.65zm5.517 5.5A8.28 8.28 0 0 1 10 18.333a8.28 8.28 0 0 1-5.617-2.183c.083-.783.583-1.55 1.475-2.15 2.283-1.517 6.017-1.517 8.283 0 .892.6 1.392 1.367 1.475 2.15z" />
      <path d="M10 18.334c4.602 0 8.333-3.731 8.333-8.333S14.602 1.667 10 1.667 1.667 5.398 1.667 10 5.397 18.334 10 18.334z" />
    </svg>
  </SVGIcon>
);

export default UserProfile;
